import { dartRound } from './types';

/**
 * 포맷 · 판정 — `lens_format_pct` · `lens_format_krw` · `lens_status_for` ·
 * `lens_soro_scene_url` 의 TS 짝.
 *
 * ⚠️ 인자가 전부 nullable 인 것은 **Dart 쪽 사정**이다(커스텀 함수 인자는 전부
 * nullable 로 생성된다 — CLAUDE.md). TS 에서는 그럴 이유가 없지만, 호출부가
 * `-1`/`undefined` 를 흘릴 수 있는 자리가 같으므로 **흡수 규칙을 그대로** 둔다.
 */

/** 비율을 소수점 한 자리 퍼센트 문자열로. ★ 음수는 「데이터 없음」이다. */
export function lensFormatPct(value?: number | null): string {
  const v = value ?? 0;
  if (v < 0) return '데이터 없음';
  return `${v.toFixed(1)}%`;
}

/** 원화에 천 단위 구분자. ★ 음수는 「데이터 없음」이다. */
export function lensFormatKrw(value?: number | null): string {
  const v = value ?? 0;
  if (v < 0) return '데이터 없음';
  // ⚠️ `dartRound` 다 — 음수 .5 에서 JS `Math.round` 와 갈린다.
  const digits = String(dartRound(v));
  let out = '';
  for (let i = 0; i < digits.length; i++) {
    if (i > 0 && (digits.length - i) % 3 === 0) out += ',';
    out += digits[i];
  }
  return `${out}원`;
}

/**
 * 값과 임계값을 견줘 `good`/`warn`/`bad` 를.
 *
 * ★ 표본 없음(`-1`)은 **위반이 아니라 `neutral`** 이다. 색을 입히지 않는다 —
 * 0% 를 「기준선 안」으로 읽으면 정반대의 판단을 유도한다.
 */
export function lensStatusFor(
  value?: number | null,
  warnAt?: number | null,
  badAt?: number | null,
  higherIsBetter?: boolean | null,
): string {
  const v = value ?? 0;
  if (v < 0) return 'neutral';
  const warn = warnAt ?? 0;
  const bad = badAt ?? 0;
  if (higherIsBetter ?? false) {
    if (v >= warn) return 'good';
    if (v >= bad) return 'warn';
    return 'bad';
  }
  if (v <= warn) return 'good';
  if (v <= bad) return 'warn';
  return 'bad';
}

/**
 * SORO 장면 딥링크.
 *
 * ★ LENS 는 **읽기 전용**이라 여는 것까지만 한다 — 수정은 SORO 에서
 * Validator 를 거쳐 한다.
 */
export function lensSoroSceneUrl(
  baseUrl?: string | null,
  campaignId?: string | null,
  contentVersion?: string | null,
  sceneId?: string | null,
): string {
  const base = !(baseUrl ?? '') ? 'https://soro.internal/scene' : baseUrl!;
  return (
    `${base}?campaign=${campaignId ?? ''}` +
    `&version=${contentVersion ?? ''}` +
    `&scene=${sceneId ?? ''}`
  );
}
